module.exports = __webpack_public_path__ + "fonts/Inter-700-cyrillic44.de93fdc.woff2";